export interface ITicketSettings {
    type: number,
    center: number,
    status: number[],
    tier: number,
    autoRefresh: number,
    dateRecorded: Date
}